<template>
  <div class="moduleOne">
    <slot></slot>
    <el-carousel
      :interval="4000"
      arrow="never"
      :height="imgHight + 'px'"
      style="cursor:pointer"
      :class="mod1.bannerDtos.bannerUrl ? sty[0] : sty[1]"
    >
      <el-carousel-item v-for="(item, index) in mod1.bannerDtos" :key="index">
        <a target="_blank" @click="jump(item.bannerUrl)">
          <img ref="image" :src="item.bannerList" class="img" />
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  // props: ["mod1"],
  props: {
    mod1: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      imgHight: "",
      sty: ["hand", "cursor"]
    };
  },
  mounted() {
    this.imgHight = (document.body.clientWidth * 650) / 2500;
    window.addEventListener("resize", () => {
      this.imgHight = this.$refs.image[0].height;
    });
  },
  methods: {
    jump(bannerUrl) {
      let temp = bannerUrl.slice(0, 7);
      if (temp === "http://") {
        window.location.href = bannerUrl;
      } else {
        window.location.href = "http://" + bannerUrl;
      }
    }
  }
};
</script>

<style lang="sass">
.moduleOne
  .el-carousel__item
    color: #475669
    font-size: 18px
    margin: 0
  .img
    width: 100%
    height: 100%
  .el-carousel__item:nth-child(2n)
    background-color: black
  .el-carousel__item:nth-child(2n+1)
    background-color: #d3dce6
  .hand
    cursor: pointer
  .cursor
    cursor: default
</style>
